import noUiSlider from "nouislider";
import {objectsEqual} from "../Helpers";
import AbstractFilters from "../AbstractFilters";

class Filters extends AbstractFilters{

    constructor(container){

        super('RoutesSearchForm.update');

        this.container = container;
        this.filterRadiusElement = null;
        this.filterResetElement = null;

        this.stateDefault = {
            radius: null,
            distance_min: null,
            distance_max: null,
            road_types: ''
        }

        const params = new URLSearchParams(window.location.href.split('?')[1]);

        this.state = {
            radius: params.get('radius') || null,
            distance_min: params.get('distance_min') ? Number.parseInt(params.get('distance_min')) : null,
            distance_max: params.get('distance_max') ? Number.parseInt(params.get('distance_max')) : null,
            road_types: params.get('road_types') ? Number.parseInt(params.get('road_types')) : ''
        }

    }

    render(){

        let self = this;

        self.filterRadiusElement = self.renderRadius();
        self.filterResetElement = self.renderResetBtn();

        self.container.find('.filters').append(self.filterRadiusElement);
        self.container.find('.filters').append(self.renderDistance());
        self.container.find('.filters').append(self.renderRoadTypes());
        self.container.append(self.filterResetElement);

        self.changeFilterResetBtn()

    }

    renderDistance(){

        let self = this;

        let el = $('<div class="filterDistance">' +
            '<input type="hidden" value="" name="distance_min">' +
            '<input type="hidden" value="" name="distance_max">' +
            '                <div class="dropdown">' +
            '                    <button type="button" class="dropdown_button">' +
            '                        <span class="flex-col">' +
            '                            <span class="flex-row align-items-center gap_1">' +
            '                                <i class="icon-event_distance"></i> <span>Distance</span> <i class="icon-chevron-down transitionTransform"></i>' +
            '                            </span>' +
            '                            <span class="text-center color-b800 filterDisplayVal"></span>' +
            '                        </span>' +
            '                    </button>' +
            '                    <div class="dropdown_menu">' +
            '                        <div class="" style="width: 400px; padding: 10px 20px 20px 20px; user-select: none">' +
            '                            <div style="font-size: 1.2em; padding-bottom: 10px">Route distance</div>' +
            '                            <div class="flex-row flex-between">' +
            '                                <div class="range-slider-fromval"></div>' +
            '                                <div class="range-slider-toval"></div>' +
            '                            </div>' +
            '                            <div class="range-slider"></div>' +
            '                        </div>' +
            '                    </div>' +
            '                </div>' +
            '            </div>')

        let sliderDistance = el.find('.range-slider');
        let sliderDistanceDisplayVal = el.find('.filterDisplayVal');

        let sliderObject = noUiSlider.create(sliderDistance[0], {
            start: [(self.state.distance_min || 0), (self.state.distance_max || 1000)], step: 10, connect: true,
            range: {
                'min': 0,
                'max': 1000
            }
        });

        sliderObject.on('update', function(values){
            el.find('.range-slider-fromval').html(Math.round(values[0]) + ' km');
            el.find('.range-slider-toval').html(Math.round(values[1]) + ' km');
        })
        sliderObject.on('change', function(values){

            el.find('input[name=distance_min]').val(Math.round(values[0]));
            el.find('input[name=distance_max]').val(Math.round(values[1]));

            self.state.distance_min = Math.round(values[0]);
            self.state.distance_max = Math.round(values[1]);

            if(
                Math.round(values[0]) !== self.stateDefault.distance_min ||
                Math.round(values[1]) !== self.stateDefault.distance_max
            ){
                sliderDistanceDisplayVal.html(Math.round(values[0]) + ' - ' + Math.round(values[1]) + ' km');
            }else{
                sliderDistanceDisplayVal.html('')
            }

            self.updateFilters();
        })

        self.container.on('reset', function(){
            sliderObject.reset();
            el.find('input[name=distance_min]').val('');
            el.find('input[name=distance_max]').val('');
            self.state.distance_min = null;
            self.state.distance_max = null;
            sliderDistanceDisplayVal.html('');
        })

        if(self.state.distance_min){
            el.find('input[name=distance_min]').val(self.state.distance_min);
            el.find('input[name=distance_max]').val(self.state.distance_max);
            sliderDistanceDisplayVal.html(self.state.distance_min + ' - ' + self.state.distance_max + ' km');
        }


        return el;

    }

    renderRoadTypes(){

        let self = this;

        let el = $('<div class="filterRoadTypes">' +
            '<input type="hidden" value="" name="road_types">' +
            '<div class="dropdown">' +
                '<button type="button" class="dropdown_button">' +
                    '<span class="flex-col">' +
                        '<span class="flex-row align-items-center gap_1">' +
                            '<span>Type Roads & Landscape</span> <i class="icon-chevron-down transitionTransform"></i>' +
                        '</span>' +
                        '<span class="text-center color-b800 filterDisplayVal"></span>' +
                    '</span>' +
                '</button>' +
                '<div class="dropdown_menu dropdownRadioItems custom-scrollbar">' +
                    '<div class="item">All<span class="listCheck"></span></div>' +
            '</div>' +
        '</div>');

        let sliderDistanceDisplayVal = el.find('.filterDisplayVal');

        el.find('.dropdownRadioItems .item').on('click',function(){
            el.find('.dropdownRadioItems > .item').removeClass('active');
            el.find('input[name=road_types]').val('');
            $(this).addClass('active');
            self.state.road_types = '';
            sliderDistanceDisplayVal.html('');
            self.updateFilters();
        })

        $.get('/ajax/routes.getRoadTypes', function(d){
            d.data.types.forEach(type => {
                let item = $('<div class="item flex-row gap_1" data-id="'+ type.id +'">' +
                    '<img width="26" class="svgBlackToWhite" src="'+ type.icon +'" alt>' +
                    '<span>'+ type.name +'</span>' +
                    '<span class="listCheck"></span>' +
                    '</div>');

                el.find('.dropdownRadioItems').append(item);

                if(self.state.road_types === type.id){
                    el.find('input[name=road_types]').val(self.state.road_types);
                    item.addClass('active');
                    sliderDistanceDisplayVal.html('<span class="inline-flex align-items-center"><img width="24" class="svgBlackToBlue" src="'+ type.icon +'" alt><span>'+type.name+'</span></span>');
                }

                item.on('click', function(e){
                    el.find('.dropdownRadioItems > .item').removeClass('active');
                    el.find('input[name=road_types]').val(type.id);
                    $(this).addClass('active');
                    sliderDistanceDisplayVal.html('<span class="inline-flex align-items-center"><img width="24" class="svgBlackToBlue" src="'+ type.icon +'" alt><span>'+type.name+'</span></span>');
                    self.state.road_types = type.id;
                    self.updateFilters();
                })
            })
        })

        self.container.on('reset', function(){
            el.find('.dropdownRadioItems > .item').removeClass('active');
            el.find('input[name=road_types]').val('');
            sliderDistanceDisplayVal.html('');
            self.state.road_types = '';
        })

        return el;

    }

}

export default Filters;